import { createComponentsRegistrySiteAssets, ILibraryTopology } from '@wix/thunderbolt-components-registry/siteAssets'

import type { FetchFn, MetricsReporter } from '@wix/thunderbolt-becky-types'
import type { ComponentsNativeMappers } from '@wix/thunderbolt-becky-root'

// Cache component mappers per topology to avoid loading them on each request
const componentMappersCache = new Map<string, Promise<ComponentsNativeMappers>>()

export const getComponentMappers = async ({
	fetchFn,
	registryLibrariesTopology,
	metricsReporter,
	isExperimentOpen,
}: {
	fetchFn: FetchFn
	registryLibrariesTopology: string
	metricsReporter: MetricsReporter
	isExperimentOpen: (specName: string) => boolean
}): Promise<ComponentsNativeMappers> => {
	if (componentMappersCache.has(registryLibrariesTopology)) {
		return componentMappersCache.get(registryLibrariesTopology)!
	}

	const libraries: Array<ILibraryTopology> = registryLibrariesTopology ? JSON.parse(registryLibrariesTopology) : []

	const registry = await createComponentsRegistrySiteAssets({
		libraries,
		modulesLoader: {
			relativeUrl: () => {
				throw new Error('ModulesLoader `relativeUrl` method should not be used')
			},
			absoluteUrl: async (url) => {
				const response = await fetchFn(url)
				return response.text() as any
			},
		},
		runAndReport: (metric, fn) => {
			return metricsReporter.runAsyncAndReport(fn, metric)
		},
		isExperimentOpen,
	})

	const componentMappers = registry.loadComponentMappers() as Promise<ComponentsNativeMappers>

	if (process.env.NODE_ENV === 'production') {
		componentMappersCache.set(registryLibrariesTopology, componentMappers)
	}

	return componentMappers
}
